import React from "react";
import styled from "styled-components/macro";

// components
import TranslateScript from "./TranslateScript";

const Button = styled.button`
  cursor: pointer;
  border-radius: 1em;
  padding: 0.2em 1em;
  margin: 0.2em 1em;
  color: #fff;
  font-weight: 700;

  border: none;
  outline: none;

  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

  background: ${({ theme, themeColor }) =>
    themeColor ? theme[themeColor] : theme.primary};

  :hover {
    background: ${({ theme, themeColor }) =>
      themeColor ? theme[`${themeColor}Tertiary`] : theme.tertiary};
    color: #fff;
    text-decoration: none;
  }

  :active {
    background: ${({ theme, themeColor }) =>
      themeColor ? theme[`${themeColor}Secondary`] : theme.secondary};
    color: #fff;
    text-decoration: none;
  }

  :focus {
    outline: none;
  }

  :disabled {
    color: #e9e9e9;
    background: #f9f9f9;
    box-shadow: none;
    cursor: not-allowed;
    border: solid 1px #e9e9e9;
  }
`;

export default ({ children, ...rest }) => {
  return (
    <Button {...rest}>
      <TranslateScript>{children}</TranslateScript>
    </Button>
  );
};
